import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BnNgIdleService } from 'bn-ng-idle';
import { SessionoutComponent } from './components/grid/sessionout/sessionout.component';
import { LoginserviceService } from './services/services/loginservice.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'RenoHRMS';

  islogin:boolean=false;

  constructor(private appService: LoginserviceService, private bnIdle: BnNgIdleService,private bnIdle1: BnNgIdleService, private productFindService: NgbModal) {

   

    this.bnIdle.startWatching(300).subscribe((res) => {
      if (res) {
       
        sessionStorage.removeItem("hrtoken");
        this.appService.fnCheckLogin();
      }
    })

    // this.bnIdle1.startWatching(30).subscribe((res) => {
    //   if (res) {        
    //     this.fnShowSessionOutPopup();
    //   }
    // })
  
  }

  ngOnInit(){
    this.appService.fnCheckLogin();
  }

  ngAfterViewChecked(): void {

    setTimeout(() =>  this.islogin=this.appService.islogin );
     
  }

  fnShowSessionOutPopup() {

    const modalRef = this.productFindService.open(SessionoutComponent, { size: <any>'l' });
    modalRef.componentInstance.sessiontime = 30;
    modalRef.componentInstance.startTimer();
    
  }


}
